import React, { useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import './loading.scss';

function Loading (props){

    const {isPending, content} = props;
    return <Modal id="upload-modal" show={isPending} onHide={isPending} centered dialogClassName="menu-modal left-aligned-modal">
    <Modal.Body className='p-4'>
        <div className='d-flex justify-content-betweeen align-items-center h-100 flex-column'>
            <h1 className='upload-modal-title'>{content}</h1>
            <div className='mt-5 d-flex justify-content-between align-items-center flex-column'>
                <div className="loader" />
            </div>
        </div>
    </Modal.Body>
    </Modal>
}

export default Loading;
